'use client';

import * as React from 'react';
import {
  BellIcon,
  TargetIcon,
  UsersIcon,
  ListIcon,
  CalendarIcon,
  TrendingUpIcon
} from 'lucide-react';

import { BlurFade } from '~/components/fragments/blur-fade';
import { GridSection } from '~/components/fragments/grid-section';
import { SiteHeading } from '~/components/fragments/site-heading';

const FEATURES = [
  {
    icon: <BellIcon className="size-5 shrink-0" />,
    title: 'Slimme herinneringen',
    description:
      'Stel automatische herinneringen in en krijg notificaties wanneer deadlines naderen. Zo vergeet je nooit meer een belangrijke taak.'
  },
  {
    icon: <TargetIcon className="size-5 shrink-0" />,
    title: 'Prioriteiten stellen',
    description:
      'Geef taken een prioriteit en sorteer ze op belangrijkheid. Focus op wat echt belangrijk is en werk efficiënt door je takenlijst.'
  },
  {
    icon: <UsersIcon className="size-5 shrink-0" />,
    title: 'Team samenwerking',
    description:
      'Wijs taken toe aan teamleden en werk samen aan projecten. Iedereen ziet wat er moet gebeuren en wie waarvoor verantwoordelijk is.'
  },
  {
    icon: <ListIcon className="size-5 shrink-0" />,
    title: 'Overzichtelijke lijsten',
    description:
      'Organiseer taken in lijsten en projecten. Gebruik tags en filters om snel te vinden wat je zoekt en houd overzicht over alles.'
  },
  {
    icon: <CalendarIcon className="size-5 shrink-0" />,
    title: 'Integratie met agenda',
    description:
      'Koppel taken aan je agenda en plan activiteiten direct. Alles staat op de juiste plek en je hebt altijd een compleet overzicht.'
  },
  {
    icon: <TrendingUpIcon className="size-5 shrink-0" />,
    title: 'Voortgang bijhouden',
    description:
      'Volg de voortgang van taken en projecten. Zie in één oogopslag wat er klaar is en wat nog moet gebeuren.'
  }
];

export function ActiviteitenEnTakenFeatures(): React.JSX.Element {
  return (
    <GridSection>
      <div className="container space-y-12 py-20 md:py-32">
        <SiteHeading
          badge="Unieke voordelen"
          title="Wat maakt Emma uniek in Activiteitenbeheer?"
          description="Ontdek de krachtige functies die Emma biedt om je activiteiten en taken efficiënt te beheren."
        />

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((feature, index) => (
            <BlurFade
              key={index}
              inView
              delay={0.1 + index * 0.1}
              className="rounded-xl border bg-card p-6 shadow-sm transition-shadow hover:shadow-md"
            >
              <div className="mb-4 flex size-12 items-center justify-center rounded-xl border bg-background text-primary">
                {feature.icon}
              </div>
              <h3 className="mb-2 text-lg font-semibold">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.description}</p>
            </BlurFade>
          ))}
        </div>
      </div>
    </GridSection>
  );
}
